import request from '@/api/request'

/**
 * 管理端获取考试列表
 */
export const getPlanItemList  = (data) => {
  return request({
    url: 'product/adm/testPlanItem/page',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 管理端添加考试
 */
export const addPlanItem  = (data) => {
  return request({
    url: 'product/adm/testPlanItem/add',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 管理端编辑考试
 */
export const updatePlanItem  = (data) => {
  return request({
    url: 'product/adm/testPlanItem/update',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 管理端删除考试
 */
export const removeTestPlanItem  = (data) => {
  return request({
    url: 'product/adm/testPlanItem/del',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 分页查询考试计划列表(学员列表)
 */
export const getUserList  = (data) => {
  return request({
    url: 'product/adm/userTestPlan/page',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 考试计划列表取消(学员列表)
 */
export const userTestPlanDel  = (data) => {
  return request({
    url: 'product/adm/userTestPlan/del',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 分页查询考试计划列表
 */
export const getListUserTestPlanSubscribe  = (data) => {
  return request({
    url: 'product/adm/userTestPlanSubscribe/page',
    data,
    method: 'post',
    type: 'json'
  })
}

/**
 * 修改证件照片
 */
export const handleUpdateImg  = (data) => {
  return request({
    url: 'product/adm/userTestPlan/updateImg',
    data,
    method: 'post',
    type: 'json'
  })
}
